import { icdCodeValidator } from './icd-code-validator.function';

export interface ICodeInfo {
  code: string;
  codeType: string;
  alternateEvidenceCode: string;
  alternateEvidenceCodeType: string;
}

export const codeTypeIcd10 = 'icd10';

export function codeValidator(config: ICodeInfo) {
  return (
    (config?.codeType === codeTypeIcd10 && icdCodeValidator(config?.code)) ||
    (config?.alternateEvidenceCodeType === codeTypeIcd10 && icdCodeValidator(config?.alternateEvidenceCode))
  );
}
